import React, { Component } from 'react';
import api from "./../../../services/api";
import './../../../pages/Profissional_Saude/Tela_Perfil/styles.css';
//import { NavLink } from 'react-router-dom';
//import GetName from './GetName';

//import da API
import { professional } from './../../../services/api';
let apiProfessional = new professional();

var token = localStorage.getItem('user_token');
var medico_id = localStorage.getItem('professional_id');

//Classe para API
export default class DataExam extends Component {
    state = {
        info: [],
    }

    componentDidMount() {
        this.loadData();


    }

    loadData = async () => {
        //const request = await api.get(`/professional/${medico_id}`, { headers: { 'x-access-token': token } });
        const request = await apiProfessional.getProfessional(medico_id);

        console.log(request);
        console.log(request.data);
        this.setState({ info: request.data });
    };

    render() {
        return (
            <>
                <div id="MainPsPerfil">
                    <h2 id="TitlePSPerfil">Perfil do(a) profissional da saúde</h2>
                    <hr id="dividerPSDados" />
                    <br></br>
                    <h1 className="TitlePSPerfilCenter">Dados do Perfil</h1>
                    <hr className="dividerPSDadosDashed" />
                    {this.state.info.map(info => (
                        <>
                            <p id="PSPerfilDados">Nome:<p>{info.name}</p></p>
                            <p id="PSPerfilDados">Email:<p>{info.email}</p></p>
                            <p id="PSPerfilDados">Gênero: <p>{info.gender}</p></p>
                            <p id="PSPerfilDados">Data de nascimento: <p>{info.birth}</p></p>
                            <p id="PSPerfilDados">Número de telefone: <p>{info.phone}</p></p>
                            <p id="PSPerfilDados">Endereço: <p>{info.adress}</p></p>
                            <p id="PSPerfilDados">RG: <p>{info.rg}</p></p>
                            <p id="PSPerfilDados">CPF: <p>{info.cpf}</p></p>
                            <p id="PSPerfilDados">CEP: <p>{info.cep}</p></p>
                            <p id="PSPerfilDados">CRM: <p>{info.crm}</p></p>
                            <p id="PSPerfilDados">Unidade federativa: <p>{info.federative_unit}</p></p>
                            <p id="PSPerfilDados">Área de ocupação: <p>{info.occupation_area}</p></p>
                            {
                                info.occupation_area === "Medicina" ? <><p id="PSPerfilDados">Especialidade: <p>{info.medical_specialty}</p></p></> :
                                    info.occupation_area !== "Medicina" ? <><p id="PSPerfilDados">Especialidade: <p>{info.health_specialty}</p></p></> :
                                        null
                            }
                            <p id="PSPerfilDados">Estado do CRM: <p>{info.regional_council_state}</p></p>
                            <p id="PSPerfilDados">Tipo de voluntário: <p>{info.voluntary_type}</p></p>
                            <hr className="dividerPSDadosDashed" />
                            <br></br>
                        </>
                    ))}
                </div>
            </>

        );
    }

}
